<template>
  <div>
    <top />
    <div class="container mianbox p20 zz_box">
      <div class="sm_name" style=" text-align:center; margin-bottom:30px; line-height:190%">政治数据</div>
      <p>
        <strong>（一）人口构成</strong>
      </p>
      <p>
        <a name="宗教人口占比（CCD）">1.1宗教人口占比（CCD）</a>
      </p>
      <p>指标说明：</p>
      <p>
        统计各国各宗教人口占本国总人口的比例。由于数据可得性受限，统计国家不包括中国（People&rsquo;s Republic of China）、越南（Republic of Vietnam）和朝鲜（Democratic
        People&rsquo;s Republic of Korea）。
      </p>
      <p>统计范围：</p>
      <p>全球165个主要国家（2004年人口在50万以上的国家），1945-2013年。</p>
      <p>
        <a name=" 宗教人口数（ARDA）">1.2宗教人口数（ARDA）</a>
      </p>
      <p>指标说明：</p>
      <p>统计各宗教人口的数量。与上述CCD数据库不同，该数据库对主要宗教各分支派别（family tree）的人口情况进行了详细统计。</p>
      <p>统计范围：</p>
      <p>全球200个主要国家，1945年至2010年，每隔5年更新一次数据。</p>
      <p>
        <a name="民族人口占比（CCD）">1.3民族人口占比（CCD）</a>
      </p>
      <p>指标说明：</p>
      <p>
        统计各国各民族人口占本国总人口的比例。由于数据可得性受限，统计国家不包括喀麦隆（Cameroon）、法国（France）、印度（India）,
        科索沃（Kosovo）、黑山共和国（Montenegro）、莫桑比克（Mozambique）和巴布亚新几内亚（Papua New Guinea）。
      </p>
      <p>统计范围：</p>
      <p>全球165个主要国家（2004年人口在50万以上的国家），1945-2013年。</p>
      <p>
        <a name="宗教人口占比（ARDA）">1.4宗教人口占比（ARDA）</a>
      </p>
      <p>指标说明：</p>
      <p>统计各宗教人口占本国总人口的比例。与上述CCD数据不同的是，该数据对主要宗教各分支派别（family tree）的人口情况进行了详细统计。</p>
      <p>统计范围：</p>
      <p>全球200个主要国家，1945年至2010年，每隔5年更新一次数据。</p>
      <p>
        <strong>（二）政府首脑</strong>
      </p>
      <p>
        <a name="9">2.1政府首脑名字及其派别 (the HoG Dataset)</a>
      </p>
      <p>指标说明：</p>
      <p>
        主要统计欧洲、拉丁美洲、北美及亚太地区各国政府首脑的意识形态倾向。参照世界银行（World
        Bank）对1975年后时期经济意识形态的编码方式，对&ldquo;政府首脑意识倾向&rdquo;变量共赋有五个值：R（Right，右派）、L（Left，左派）、C（Center，中立派）、O（Other，其他）或NA（数据不可得）。
      </p>
      <div align="center">
        <table class="tableborder1" align="center" cellspacing="0" cellpadding="8">
          <tbody>
            <tr height="43">
              <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                <p>R</p>
              </td>
              <td valign="top" width="505" height="0">
                <p>右派</p>
              </td>
            </tr>
            <tr height="43">
              <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                <p>L</p>
              </td>
              <td valign="top" width="505" height="0">
                <p>左派</p>
              </td>
            </tr>
            <tr height="43">
              <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                <p>C</p>
              </td>
              <td valign="top" width="505" height="0">
                <p>中立派</p>
              </td>
            </tr>
            <tr height="43">
              <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                <p>O</p>
              </td>
              <td valign="top" width="505" height="0">
                <p>其他</p>
              </td>
            </tr>
            <tr height="43">
              <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                <p>NA</p>
              </td>
              <td valign="top" width="505" height="0">
                <p>无数据</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>统计范围：</p>
      <p>33个国家地区，1870-2012年。</p>
      <p>
        <a name="6">2.2 最高统帅、选举和非法治理（REIGN数据库）</a>
      </p>
      <p>指标说明：</p>
      <p>按照领导人序列，统计各国掌握实权的最高领导人（Rulers）的执政起止日期、出生年份、性别、有无从军经历、选举事件、突发事件、政变风险等信息。</p>
      <p>统计范围：</p>
      <p>1950年1月-2017年8月，201个国家地区</p>
      <p>
        <a name="5">2.3国家领导人名单（PLAD数据库）</a>
      </p>
      <p>指标说明：</p>
      <p>PLAD数据库包含1989-2020年期间全球177个国家和地区有效领导人的出生地和种族信息，报告了1109位有效领导人的信息。该数据集遵循Archigos政治领导人数据库中的定义（Goemans等人，2009），最高精度达到村庄或城市级别。关于领导人种族信息准确度：1=有两个直接的信息来源；2=只有一条直接来源或其中一个来源为维基；3=无直接提到的种族信息，通过文字或图片相关信息得出。</p>
      <p>统计范围：</p>
      <p>1989-2020年，177个国家和地区</p>
      <p>
        <a name="4">2.4国家领导人名单及所在政党（REIGN1）</a>
      </p>
      <p>指标说明：</p>
      <p>按照时间序列，统计各国每年每月掌握实权的最高领导人（Rulers）的年龄、性别、以前是否担任过领导人、有无军队背景、政治体制特征、选举事件、突发事件、政变风险等信息。同时，我们还参考其他来源，添加了国家领导人所在政党信息。</p>
      <p>统计范围：</p>
      <p>1950年1月-2021年6月，201个国家和地区。</p>
      <p>
        <a id="4" name="11">2.5执政党名单（DPI）</a>
      </p>
      <p>指标说明：</p>
      <p>
        该数据库统计各国领导人（chief
        executive）所在政党、该政党的左右派别、政治体制等信息。若各个变量数据不可得，则统一赋值为-999。若领导人为独立身份，或者是最高统治者，或在军队服役，或为无党派人士，则&ldquo;领导人所在政党&rdquo;变量赋值为&ldquo;Independent&rdquo;。若无法区分所在政党为左派、中立或者右派，&ldquo;政党左右派别&rdquo;变量赋值为0。
      </p>
      <p>统计范围：</p>
      <p>1975-2020年，182个国家地区</p>
      <p>执政党名单（DPI）&ldquo;领导人所在政党&rdquo;简称与全称对照表</p>
      <div align="center">
        <table class="tableborder1" align="center" cellspacing="0" cellpadding="8">
          <colgroup>
            <col width="123" />
            <col width="94" />
            <col width="132" />
            <col width="293" />
          </colgroup>
          <tbody>
            <tr height="19">
              <td width="220" height="19" valign="bottom" bgcolor="#f0f0f0">
                <p>国家</p>
              </td>
              <td width="172" height="19" valign="bottom" bgcolor="#f0f0f0">
                <p>政党成立年份</p>
              </td>
              <td width="302" height="19" valign="bottom" bgcolor="#f0f0f0">
                <p>政党简称</p>
              </td>
              <td width="440" height="19" valign="bottom" bgcolor="#f0f0f0">
                <p>政党全称</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Angola</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>CASA-CE</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Broad Convergence for the Salvation of Angola</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Albania</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2011</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>PDIU</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Party for Justice, Integration, and Unity</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Argentina</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2013</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Renewal Front</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Renewal Front</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Armenia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2008</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Armenian National Congress</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Armenian National Congress</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Australia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2008</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>LNP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Liberal National Party (Queensland)</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Austria</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Team Stronach</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Team Stronach for Austria (Team Stronach f&uuml;r &Ouml;sterreich)</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Bangladesh</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>BWP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Bangladesh Workers' Party</p>
              </td>
            </tr>
            <tr height="21">
              <td valign="bottom" width="220" height="21">
                <p>Belarus</p>
              </td>
              <td valign="bottom" width="172" height="21">
                <p>1993</p>
              </td>
              <td valign="bottom" width="302" height="21">
                <p>RPPS</p>
              </td>
              <td valign="bottom" width="440" height="21">
                <p>Respublikanskaya Partya Pratsy i Spravyadlivasti</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Bolivia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>PDC</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Partido Democrata Cristiano/ Christian Democratic Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Brazil</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>&nbsp;</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>PSD</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Partido Social Democratico</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Botswana</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>UDC</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Umbrella for Democratic Change</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Central African Republic</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Majorit&eacute; Pr&eacute;sidentielle</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Majorit&eacute; Pr&eacute;sidentielle</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Central African Republic</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Coalition</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Coalition (Seleka)</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Chile</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2013</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>New Majority</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>New Majority</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Chile</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>&nbsp;</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Alliance</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Alliance</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Chile</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2013</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>If You Want It, Chile Changes</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>If You Want It, Chile Changes</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Cameroon</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>MRC</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Cameroon Renaissance Movement</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Colombia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2014</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>DC</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Democratic Center</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Colombia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2007</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>VC</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Colombian Green Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Colombia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2013</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>POC</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Citizen's Option Party (formerly NIP)</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Costa Rica</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2004</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>FA</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Broad Front</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Algeria</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>MPA</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Popular Algerian Movement</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Algeria</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>AAV</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Green Algeria Alliance</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Algeria</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>FFS</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Socialist Forces Front</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Ecuador</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2010</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>CREO</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Creating Opportunities</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Fiji</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2014</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>FijiFirst</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>FijiFirst Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Fiji</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2013</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>SODELPA</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Social Democratic Liberal Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Fiji</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>1963</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>NFP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>National Federation Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Georgia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2011</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>GD-DG</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Georgian Dream-Democratic Georgia</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Guinea</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>RPG</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Rally of the Guinean People</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Guinea</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2009</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>PEDN</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Party of Hope for National Development</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Guinea</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>1991</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>UFDG</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Union of Democratic Forces of Guinea</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Guinea-Bissau</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>PCD</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Democratic Convergence Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Greece</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2004</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>SYRIZA</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Coalition of the Radical Left</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Greece</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>ANEL</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Independent Greeks</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Hungary</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2014</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Change of Government</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Change of Government/Electoral Alliance Unity</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>India</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>1999</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>NCP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>National Congress Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>India</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>1997</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>RJD</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Rashtriya Janata Dal</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Iran</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>late 1970s</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>JRM</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Society of Combatant Clergy</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Iraq</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>1950s</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Islamic Call</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Islamic Call/ Al Dawah</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Iraq</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>al-SADR movement</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>al-SADR movement</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Iraq</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2014</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Citizen Alliance</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Citizen Alliance</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Iraq</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>National Coalition</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>National Coalition</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Iraq</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Muttahidoon</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Muttahidoon/Uniters for Reform Coalition</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Iceland</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Bright Future</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Bright Future</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Israel</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Yesh Atid</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Yesh Atid</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Israel</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>UTJ</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>United Torah Judaism</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Italy</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2010</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>SEL</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Left Ecology Freedom</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Italy</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>CD</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Democratic Center</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Italy</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>FdI-CN</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Brothers of Italy-National Center Right</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Japan</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>JRP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Japan Restoration Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Japan</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2009</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Your Party</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Your Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Kenya</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>TNA</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>The National Alliance</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Kenya</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2013</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>URP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>United Republican Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Kenya</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>UDF</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>United Democratic Forum</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Kenya</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>WDM-K</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Wider Democratic Movement-K</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Kyrgyzstan</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>1999</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Ar-namys</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Ar-namys/Dignity</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Kyrgyzstan</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>1993</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Socialist Party Fatherland</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Socialist Party Fatherland</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Kyrgyzstan</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2004</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Fatherland</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Fatherland</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Kyrgyzstan</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2010</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Republic</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Republic</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Kyrgyzstan</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>CNRP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Cambodian National Rescue Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>ROK</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>NFP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>New Frontier Party (formerly GNP)</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>ROK</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>FUP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Forward Unification Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Lesotho</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>DC</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Democratic Congress</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Lithuania</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>DK</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>The Way of Courage</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Luxembourg</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>1999</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>The Left</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>The Left</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Latvia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2011</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>ZRP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Zatler's Reform Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Latvia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2011</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>NA-VL-TB/LNNK</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>National Alliance &amp;QUOT;All for Latvia&amp;QUOT;-For Fatherland and Freedom/LNNK</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Latvia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2014</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>LRA</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Latvian Association of Regions</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Latvia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2014</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>NSL</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>For Latvia from the Heart</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Moldova</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2013</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>PSRM</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Party of Socialists of the Republic of Moldova</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Madagascar</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>A New Force for Madagascar</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>A New Force for Madagascar</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Madagascar</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2013</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>MAPAR</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>With President Andry Rajoelina</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Madagascar</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2013</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>VPM-MMM</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Vondrona Politika Miara-Dia&mdash;Malagy Miara-Miainga</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Madagascar</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2013</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>We'll All Be Together</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>We'll All Be Together</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Maldives</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2011</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>PPM</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Progressive Party of the Maldives</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Maldives</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2008</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>NUP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>National Unity Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Maldives</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2013</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>MDA</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Maldives Development Alliance</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Maldives</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2005</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>AP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Justice Party (Adhaalath Party)</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Macedonia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2014</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Coalition Citizen Option for Macedonia</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Coalition Citizen Option for Macedonia</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Mongolia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>CW-GP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Civic Will-Green Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Mongolia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Justice Coalition</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Justice Coalition</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Mongolia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>1921</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>MPP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Mongolia People's Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Mauritania</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2007</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>RNRD</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>National Rally for Reform and Development</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Mauritania</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>PEDS</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Party of the Democratic and Social Agreement</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Malawi</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2011</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>PP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>People's Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Malaysia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>PR</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>People's Alliance</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Namibia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2008</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>APP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>All People's Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Pakistan</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>1950</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>JUI-F</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Jamiat-Ulema-e-Islam Fazlur Rahman Group</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Pakistan</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>1992</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>PML-F</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Pakistan Muslim League-Functional</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Pakistan</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>1996</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>PTI</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Pakistan Movement for Justice</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Philippines</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>UNA</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>United Nationalist Alliance</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Philippines</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2011</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>NUP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>National Unity Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>PNG</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>THE</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Triumph Heritage Empowerment Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>PNG</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2007</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>MLP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Melanesian Liberal Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>PNG</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>CR</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Coalition for Reform</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>PNG</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>PMC</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>People's Movement for Change</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Senegal</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2008</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>APR-Yakaar</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Alliance for the Republic-Hope</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Senegal</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>BBY</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>United in Hope Coalition</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Senegal</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Bokk Gis Gis</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>United for a Common Vision Coalition</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Senegal</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Bes Du Niak</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Citizen Movement for Reform</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Solomon Islands</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2001</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>UDP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>United Democratic Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Solomon Islands</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Kadere</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Kadere Party of Solomon Islands</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Solomon Islands</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>DAP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Democratic Alliance Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>El Salvador</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2011</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>PES</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Party of Hope</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Slovakia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2011</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>OLanO</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Ordinary People and Independent Personalities</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Slovakia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2009</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>MH</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Bridge</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Slovenia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2014</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>SMC</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Party of Miro Cerar</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Slovenia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2014</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>ZL</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>United Left</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Slovenia</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2000</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>NSI</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>New Slovenia-Christian People's Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Togo</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>UNIR</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Union of the Republic</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Turkmenistan</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2012</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>PIE</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Party of Industrialists and Entrepreneurs</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Timor Leste</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2011</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Reform Front</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Reform Front</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Ukraine</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>BPP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Petro Poreshenko Blox</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Ukraine</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2014</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Samopomich</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Self-Reliance</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Ukraine</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2014</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Opposition bloc</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Opposition bloc</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Ukraine</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Freedom</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Freedom</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Ukraine</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2014</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>PF</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>People's Front</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Vanuatu</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2001</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>VGP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Vanuatu Green Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Vanuatu</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>RMC</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Reunification Movement for Change</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Vanuatu</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>Na-Griamel</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Na-Griamel Movement</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Vanuatu</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2010</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>GJP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Land and Justice Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Czech Republic</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2009</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>SPOZ</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Party of Civic Rights</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Czech Republic</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2011</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>ANO 2011</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Action of Dissatisfied Citizens 2011</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Czech Republic</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2009</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>TOP 09</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>TOP 09</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Nepal</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2009</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>MJF-L</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Madhesi People's Rights Forum (Democratic)</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Nepal</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>RPP</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>National Democratic Party</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Burkina Faso</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2007</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>CFD-B</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Convention of Democratic Forces of Burkina</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Burkina Faso</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>无信息</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>UPC</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Union for Progress and Change</p>
              </td>
            </tr>
            <tr height="19">
              <td valign="bottom" width="220" height="19">
                <p>Burkina Faso</p>
              </td>
              <td valign="bottom" width="172" height="19">
                <p>2009</p>
              </td>
              <td valign="bottom" width="302" height="19">
                <p>UNIR/PS</p>
              </td>
              <td valign="bottom" width="440" height="19">
                <p>Union for Rebirth/Sankarist Party</p>
              </td>
            </tr>
          </tbody>
        </table>
        <p>
          <a name="8">2.6军事最高统帅</a>
        </p>
        <p>指标说明：</p>
        <p>
          参照维基百科Wikipedia，系统整理各国历任武装力量最高统帅（Commander-in-chief）的执政起止日期、其他职务等信息。其中有16个国家没有正规武装力量（official military
          forces），因此无相关信息。
        </p>
        <p>统计范围：</p>
        <p>1945-2017年9月，226个国家地区</p>
        <p>无正规武装力量国家名单</p>
        <div align="center">
          <table class="tableborder1" align="center" cellspacing="0" cellpadding="8">
            <colgroup>
              <col width="92" />
              <col width="476" />
            </colgroup>
            <tbody>
              <tr height="22">
                <td width="93" height="22" valign="top" bgcolor="#f0f0f0">
                  <p>序号</p>
                </td>
                <td width="476" height="22" bgcolor="#f0f0f0">
                  <p>无正规武装力量的国家</p>
                </td>
              </tr>
              <tr height="27">
                <td valign="top" width="93" height="27">
                  <p>1</p>
                </td>
                <td width="476" height="27">
                  <p>Andorra</p>
                </td>
              </tr>
              <tr height="27">
                <td valign="top" width="93" height="27">
                  <p>2</p>
                </td>
                <td width="476" height="27">
                  <p>Costa Rica</p>
                </td>
              </tr>
              <tr height="27">
                <td valign="top" width="93" height="27">
                  <p>3</p>
                </td>
                <td width="476" height="27">
                  <p>Dominica</p>
                </td>
              </tr>
              <tr height="27">
                <td valign="top" width="93" height="27">
                  <p>4</p>
                </td>
                <td width="476" height="27">
                  <p>Grenada</p>
                </td>
              </tr>
              <tr height="27">
                <td valign="top" width="93" height="27">
                  <p>5</p>
                </td>
                <td width="476" height="27">
                  <p>Kiribati</p>
                </td>
              </tr>
              <tr height="27">
                <td valign="top" width="93" height="27">
                  <p>6</p>
                </td>
                <td width="476" height="27">
                  <p>Liechtenstein</p>
                </td>
              </tr>
              <tr height="27">
                <td valign="top" width="93" height="27">
                  <p>7</p>
                </td>
                <td width="476" height="27">
                  <p>Marshall Islands</p>
                </td>
              </tr>
              <tr height="27">
                <td valign="top" width="93" height="27">
                  <p>8</p>
                </td>
                <td width="476" height="27">
                  <p>Federated States of Micronesia</p>
                </td>
              </tr>
              <tr height="27">
                <td valign="top" width="93" height="27">
                  <p>9</p>
                </td>
                <td width="476" height="27">
                  <p>Nauru</p>
                </td>
              </tr>
              <tr height="27">
                <td valign="top" width="93" height="27">
                  <p>10</p>
                </td>
                <td width="476" height="27">
                  <p>Palau</p>
                </td>
              </tr>
              <tr height="27">
                <td valign="top" width="93" height="27">
                  <p>11</p>
                </td>
                <td width="476" height="27">
                  <p>Saint Lucia</p>
                </td>
              </tr>
              <tr height="27">
                <td valign="top" width="93" height="27">
                  <p>12</p>
                </td>
                <td width="476" height="27">
                  <p>Saint Vincent and the Grenadines</p>
                </td>
              </tr>
              <tr height="27">
                <td valign="top" width="93" height="27">
                  <p>13</p>
                </td>
                <td width="476" height="27">
                  <p>Samoa</p>
                </td>
              </tr>
              <tr height="27">
                <td valign="top" width="93" height="27">
                  <p>14</p>
                </td>
                <td width="476" height="27">
                  <p>Solomon Islands</p>
                </td>
              </tr>
              <tr height="27">
                <td valign="top" width="93" height="27">
                  <p>15</p>
                </td>
                <td width="476" height="27">
                  <p>Tuvalu</p>
                </td>
              </tr>
              <tr height="27">
                <td valign="top" width="93" height="27">
                  <p>16</p>
                </td>
                <td width="476" height="27">
                  <p>Vatican City</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          <strong>（三）选举方式</strong>
        </p>
        <p>3.1指标说明：</p>
        <p>具体二级指标包括：政府首脑的产生方式、省（州）一级政府首脑是否由地方选举产生、市（郡）一级政府首脑是否由地方选举产生、地方政府是否有自主征税权。</p>
        <p>统计范围：</p>
        <p>1975-2020年，182个国家和地区</p>
        <p>
          <a name="政府首脑的产生方式">3.1首脑的产生方式</a>
        </p>
        <p>首脑产生方式共分以下七种，并根据不同情况赋值1-7：</p>
        <div align="center">
          <table class="tableborder1" align="center" cellspacing="0" cellpadding="8">
            <colgroup>
              <col width="64" />
              <col width="504" />
            </colgroup>
            <tbody>
              <tr height="43">
                <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>1分</p>
                </td>
                <td valign="top" width="505" height="0">
                  <p>没有政府首脑</p>
                </td>
              </tr>
              <tr height="43">
                <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>2分</p>
                </td>
                <td valign="top" width="505" height="0">
                  <p>政府首脑未经选举产生</p>
                </td>
              </tr>
              <tr height="43">
                <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>3分</p>
                </td>
                <td valign="top" width="505" height="0">
                  <p>政府首脑经由选举产生，但竞选只有一位候选人</p>
                </td>
              </tr>
              <tr height="43">
                <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>4分</p>
                </td>
                <td valign="top" width="505" height="0">
                  <p>参加竞选的只有一个政党，多位候选人</p>
                </td>
              </tr>
              <tr height="43">
                <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>5分</p>
                </td>
                <td valign="top" width="505" height="0">
                  <p>多个政党都是合法的，但是只有一个政党赢得席位</p>
                </td>
              </tr>
              <tr height="43">
                <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>6分</p>
                </td>
                <td valign="top" width="505" height="0">
                  <p>多个政党赢得席位，但第一大政党赢得总席位的75%以上</p>
                </td>
              </tr>
              <tr height="43">
                <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>7分</p>
                </td>
                <td valign="top" width="505" height="0">
                  <p>第一大政党赢得总席位比例不足75%</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>对符合以下条件的政府首脑根据以上赋值标准进行赋值：</p>
        <p>通过民众选举产生，或；</p>
        <p>通过民众选举产生的选举团选举产生，而且其唯一目标是通过选举成为政府首脑</p>
        <p>除上述两类机构以外，由其他机构选举产生的政府头脑的赋值等于该选举机构的赋值。即使是该选举机构不是在政治制度数据库&ldquo;立法机构&rdquo;指标中跟踪的立法机构，仍然用该机构的赋值作为首脑的赋值。</p>
        <p>如果选举产生的总统被弹劾，并由副总统依法合理继任，则原分值保持不变。如果原分值为7，则新总统继任后分值仍为7。</p>
        <p>通过竞选产生的首相得分为6或7。</p>
        <p>共产主义国家的政府首脑（共产党主席）赋值为3，因为他们是通过党代表大会产生的，这是非指定的选举机构。</p>
        <p>政府首脑是通过公投和民意投票得到的而未经选举产生的，赋值为3。</p>
        <p>由指定的小型团体或指定的选举人团选举产生的政府首脑赋值为2。</p>
        <p>如果政府首脑单方面延长其任期，则在本该举行选举的年份赋值为2。任何通过选举产生的终身制政府首脑，即便能由大众选举或选择大会产生，赋值仍然为2。</p>
        <p>如果通过政变取得政府首脑地位，且不是通过选举来保持其地位的，则赋值为2。</p>
        <p>在武装冲突的情况下，一国的反对党上位，则该党的党魁被认为不是国家首脑，赋值为1。</p>
        <p>立法机构产生方式的赋值标准:</p>
        <div align="center">
          <table class="tableborder1" align="center" cellspacing="0" cellpadding="8">
            <colgroup>
              <col width="64" />
              <col width="504" />
            </colgroup>
            <tbody>
              <tr height="43">
                <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>1分</p>
                </td>
                <td valign="top" width="505" height="0">
                  <p>没有立法机构</p>
                </td>
              </tr>
              <tr height="43">
                <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>2分</p>
                </td>
                <td valign="top" width="505" height="0">
                  <p>立法机构未经选举产生</p>
                </td>
              </tr>
              <tr height="43">
                <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>3分</p>
                </td>
                <td valign="top" width="505" height="0">
                  <p>立法机构经由选举产生，但竞选只有一位候选人</p>
                </td>
              </tr>
              <tr height="43">
                <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>4分</p>
                </td>
                <td valign="top" width="505" height="0">
                  <p>参加竞选的只有一个政党，多位候选人</p>
                </td>
              </tr>
              <tr height="43">
                <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>5分</p>
                </td>
                <td valign="top" width="505" height="0">
                  <p>多个政党都是合法的，但是只有一个政党赢得席位</p>
                </td>
              </tr>
              <tr height="43">
                <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>6分</p>
                </td>
                <td valign="top" width="505" height="0">
                  <p>多个政党赢得席位，但第一大政党赢得总席位的75%以上</p>
                </td>
              </tr>
              <tr height="43">
                <td width="65" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>7分</p>
                </td>
                <td valign="top" width="505" height="0">
                  <p>第一大政党赢得总席位比例不足75%</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>&nbsp;</p>
        <p>在&ldquo;阵线党&rdquo;的情况下（多数共产主义国家的情况），使用与立法机构同样的赋值标准来区分单一政党执政与多个政党轮流执政。</p>
        <p>如果多个政党赢得席位，但不确定最大政党的席位数量，则赋值为6.5。</p>
        <p>如果不确定是多个政党参选、单一政党获选还是多个政党参选并获得75%以上的席位，则赋值为5.5。</p>
        <p>如果存在通过选举产生的立法机构，但政党不参与立法机构（即由无党派人士构成），则立法机构赋值为4。</p>
        <p>如果不确定在单一政党体制中选举产生的立法委员间有无竞争，则赋值为3.5。</p>
        <p>指定的咨询委员会（在中东和北非地区广泛运用）如果拥有立法权，则赋值为2。</p>
        <p>
          <a name="省（州）一级政府首脑是否由地方选举产生">3.2省（州）一级政府首脑是否由地方选举产生</a>
        </p>
        <p>如果省（州）政府首脑并非由地方选举产生，则指标赋值为0。如果政府首脑通过委任产生，但立法机构通过选举产生，则指标赋值为1。如果没有市（郡）政府信息或相关依据，则指标对应单元格为空。如果有多层次的亚国家政府机构，我们认为最高层次的亚国家政府机构为省（州）政府。非直接选举产生的省（州）政府，即由直接选举产生的市（郡）政府机构选举产生的省（州）政府，不作为由地方选举产生的省（州）一级政府。由直接选举产生的省（州）政府机构间接选举产生的省（州）政府，作为由地方选举产生的省（州）一级政府。</p>
        <p>
          <a name="市（郡）一级政府首脑是否由地方选举产生">3.3市（郡）一级政府首脑是否由地方选举产生</a>
        </p>
        <p>如果市（郡）政府首脑并非由地方选举产生，则指标赋值为0。如果政府首脑通过委任产生，但立法机构通过选举产生，则指标赋值为1。如果没有市（郡）政府信息或相关依据，则指标栏为空。</p>
        <p>
          <a name="地方政府是否有自主征税权">3.4地方政府是否有自主征税权</a>
        </p>
        <p>如果省（州）一级政府有征税、支出或立法权之中任意一项，则该指标赋值为1。如果没有信息或相关依据，则指标栏为空。</p>
        <p>
          <strong>（四）执行方式</strong>
        </p>
        <p>4.1指标说明：</p>
        <p>具体二级指标包括：是否联合政府、议会第一大执政党席位、议会第二大执政党席位、议会第三大执政党席位。</p>
        <p>统计范围：</p>
        <p>1975-2020年，182个国家和地区</p>
        <p>
          <a name="是否联合政府">4.1 是否联合政府</a>
        </p>
        <p>该指标赋值是根据原数据推算得出：如果执政党第二大党席位不为零，则为联合政府，赋值为1，否则为非联合政府，赋值为0。当年举行大选，数据在次年更新，议会席位数据采取相同的规则。2016年数据为2015年举行大选后更新的结果。</p>
        <p>
          <a name="议会第一大执政党席位">4.2 议会第一大执政党席位</a>
        </p>
        <p>该指标赋值为该国家第一大执政党的席位数量。</p>
        <p>
          <a name="议会第二大执政党席位">4.3 议会第二大执政党席位</a>
        </p>
        <p>该指标赋值为该国家第二大执政党的席位数量。</p>
        <p>
          <a name="议会第三大执政党席位">4.4 议会第三大执政党席位</a>
        </p>
        <p>该指标赋值为该国家第三大执政党的席位数量。</p>
        <p>
          <strong>（五）贪腐程度</strong>
        </p>
        <p>
          <a name="商业贿赂风险">5.1商业贿赂风险指数</a>
        </p>
        <p>指标说明：</p>
        <p>商业贿赂风险模型由四个一级指标组成：</p>
        <p>（1）与政府的业务互动；</p>
        <p>（2）反贿赂法律和执法；</p>
        <p>（3）政府与公共服务透明度；</p>
        <p>（4）公民社会监督能力</p>
        <p>其中每个指标都有多个子指标。例如，第一个指标包括&ldquo;与政府的联系&rdquo;、&ldquo;行贿预期&rdquo;和&ldquo;监管负担&rdquo;，这些指标反映了与政府联系的各个方面，模型将其视为商业贿赂非常重要的指标。第二个指标为各个国家是否颁布反腐败法及其执行情况。第三个指标涉及政府与公共服务的透明度，包括政府预算是否公开，是否具备应对公务员利益冲突的规章制度等。第四个指标反映的是媒体近用权和国有化程度。</p>
        <p>
          风险指数的计算过程如下：首先，对每个指标进行标准化，然后计算每个国家子指标内所有项目的平均得分，以给出子指标得分。 然后，对子指标分数重新标准化（标准偏差1和平均值0），并得出所有四个指标中所有分数的平均值。最后，将各指标得分按比例放大至最小值1和最大值100之间，并计算出各个指标的加权平均分。风险总分数计算公式为：domain_1
          * 0.450 + domain_2 * 0.079 + domain_3 * 0.238 + domain_4 * 0.238。
        </p>
        <p>统计范围：</p>
        <p>200个国家和地区，2014年，2016年-2021年。</p>
        <p>
          <a name="清廉指数">5.2清廉指数</a>
        </p>
        <p>指标说明：</p>
        <p>清廉指数反映的是一国家政府官员的廉洁程度和受贿状况。清廉指数采用百分制，得分越高，表示腐败程度越低。100分表示最廉洁；0分表示最腐败；80&mdash;100之间表示比较廉洁；50&mdash;80之间为轻微腐败；25&mdash;50之间腐败比较严重；0&mdash;25之间则为极端腐败。</p>
        <div align="center">
          <table class="tableborder1" align="center" cellspacing="0" cellpadding="8">
            <colgroup>
              <col width="102" />
              <col width="466" />
            </colgroup>
            <tbody>
              <tr height="43">
                <td width="102" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>0&mdash;25分</p>
                </td>
                <td valign="top" width="467" height="0">
                  <p>极端腐败</p>
                </td>
              </tr>
              <tr height="43">
                <td width="102" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>25&mdash;50</p>
                </td>
                <td valign="top" width="467" height="0">
                  <p>腐败比较严重</p>
                </td>
              </tr>
              <tr height="43">
                <td width="102" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>50&mdash;80</p>
                </td>
                <td valign="top" width="467" height="0">
                  <p>轻微腐败</p>
                </td>
              </tr>
              <tr height="43">
                <td width="102" height="0" valign="top" bgcolor="#f0f0f0">
                  <p>80&mdash;100</p>
                </td>
                <td valign="top" width="467" height="0">
                  <p>比较廉洁</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>统计范围：</p>
        <p>1995-2021年，180个国家和地区。</p>
        <p>
          <a>（六）政府规模</a>
        </p>
        <p>
          本数据库的政府规模数据有两大来源。第一是世界银行《公共领域的规模：政府工资与公职人员》数据库，提供2000-2013年期间95个国家政府人员占人口比、政府人员薪酬占总支出比、政府人员薪酬占GDP比，及政府人员薪酬占财政收入比方面的数据。第二是选取Fraser编制的Economic
          Freedom
          Index中的一级指标&ldquo;政府规模&rdquo;作为公务员规模的替代性指标，表示在多大程度上依赖于政治进程来分配资源、物资和服务。该指数自1970年起发布，覆盖159个国家，最近一次更新在2015年。
        </p>
        <p>
          <a name="公共部门人员占全体就业比（世行）">6.1公共部门人员占全体就业比（世行）</a>
        </p>
        <p>指标说明：</p>
        <p>公共部门人员占全体就业比。</p>
        <p>统计范围：</p>
        <p>2000-2018年，198个国家和地区</p>
        <p>
          <a name="政府规模">6.2政府规模(Fraser)</a>
        </p>
        <p>指标说明：</p>
        <p>经济自由度指数的一级指标&ldquo;政府规模&rdquo;和各个二级子指标的得分介于0-10之间。当存在子指标时，各个子指标的得分被平均以导出一级指标的得分。其中，&ldquo;政府规模&rdquo;一级指标下包含了&ldquo;政府支出&rdquo;&ldquo;转移支付与补贴&rdquo;&ldquo;政府企业与投资&rdquo;&ldquo;最高边际税率&rdquo;这四个二级指标，但二级指标中的权重比例并未说明。</p>
        <p>统计范围：</p>
        <p>1970-2019年，162个国家和地区。</p>
        <p>
          <a name="政府人员薪酬占总支出比（世行）">6.3政府人员薪酬占公共开支比（世行）</a>
        </p>
        <p>指标说明：</p>
        <p>政府人员薪酬占公共开支比即政府人员薪酬占公共开支的百分比。政府人员薪酬的占比指标选取自国际货币基金组织2016年的政府薪酬和就业数据集。政府人员薪酬被定义为支付给政府雇员工作的总薪酬（现金或实物），包括工资和薪金、津贴以及为雇员向社会保险计划缴纳的社保（IMF 2014）。</p>
        <p>统计范围：</p>
        <p>2000-2018年，198个国家和地区。</p>
        <p>
          <a name="政府人员薪酬占GDP比（世行）">6.4政府人员薪酬占GDP比（世行）</a>
        </p>
        <p>指标说明：</p>
        <p>政府人员薪酬占GDP比</p>
        <p>统计范围：</p>
        <p>2000-2018年，198个国家和地区。</p>
        <p>
          <strong>（七）武力冲突</strong>
        </p>
        <!-- </p> -->
        <!-- <p>
          <a name="恐怖袭击事件次数（兰德）">7.1恐怖袭击事件次数（兰德）</a>
        </p>
        <p>指标说明：</p>
        <p>本指标是通过对兰德恐怖袭击数据库中的全部恐怖袭击事件按年份和国家进行统计得到的。</p>
        <p>恐怖袭击事件由行为性质界定，而不是由罪犯身份或原因性质界定。关键要素包括：暴力或暴力威胁；旨在制造恐惧和恐慌；企图胁迫特定行为；动机必须包含政治目标；通常以民众为目标；可以是团体组织或个人。</p>
        <p>统计范围：</p>
        <p>全球199个国家，1968-2010年。</p>-->
        <p>
          <a name="恐怖袭击事件次数（马里兰）">7.1恐怖袭击事件次数（马里兰）</a>
        </p>
        <p>指标说明：</p>
        <p>根据全球恐怖主义数据库的定义，恐怖袭击是指非国家行为者威胁或实际使用非法武力和暴力，通过制造恐慌、胁迫或恐吓等手段以实现政治、经济、宗教或社会目的。这意味着纳入全球恐怖主义数据库的恐怖袭击须满足一下三个特征：事件必须是蓄意的；事件必须具备某种程度的暴力或直接暴力威胁；施暴者必须是次国家行为人。本数据库不包含国家恐怖主义行为。</p>
        <p>全球恐怖主义数据库不包含未实施的恐怖袭击策划或阴谋。纳入全球恐怖主义数据库的恐怖袭击必须是付诸实施的。全球恐怖主义数据库也不含未成功的恐怖袭击。不过，若炸弹已被安置但没有引爆，或纵火犯或暗杀者被当局拦截，这类袭击被纳入全球恐怖主义数据库，但注明成功=0。</p>
        <p>统计范围：</p>
        <p>1970-2019年，205个国家和地区。</p>
        <p>
          <a name="恐怖袭击死亡人数（马里兰）">7.2恐怖袭击死亡人数（马里兰）</a>
        </p>
        <p>指标说明：</p>
        <p>死亡人数指的是经确认的死亡总人数，包括事件直接导致死亡的受害者和袭击者。</p>
        <p>若存在死亡人数证据，但没有报告或数字过于含糊不清，则列表仍为空白。若缺少袭击遇难受害者死亡人数的信息，但已知犯罪者死亡人数，数值仅反映为事件导致的犯罪者死亡人数。同理，如果缺少犯罪者死亡人数，但已知受害者死亡人数，则报告中只含受害者死亡人数。</p>
        <p>统计范围：</p>
        <p>1970-2019年，205个国家和地区。</p>
        <p>
          <a name="恐怖袭击受伤人数（马里兰）">7.3恐怖袭击受伤人数（马里兰）</a>
        </p>
        <p>指标说明：</p>
        <p>受伤人数指的是被确认的导致非致命伤害的人数，包括罪犯和受害者。统计规则同死亡人数。</p>
        <p>统计范围：</p>
        <p>1970-2019年，205个国家和地区。</p>
        <p>
          <a name="武装冲突发生次数（UCDP）">7.4武装冲突发生次数（UCDP）</a>
        </p>
        <p>指标说明：</p>
        <p>根据UCDP对武装冲突的定义，发生次数指的是一年中至少有一方为国家政府参与，使用武力解决政府或领土争议，且战斗相关死亡人数超过25人的事件次数。数据库中列出了每个冲突，并给出唯一的ID标识码。对于同一争议问题赋予相同ID标识码，而不论其时间如何。缺失数据的标识码为-99。</p>
        <p>统计范围：</p>
        <p>1946-2020年，159个国家和地区。</p>
        <p>
          <a name="武装冲突战斗死亡人数（UCDP）">7.5武装冲突战斗死亡人数（UCDP）</a>
        </p>
        <p>指标说明：</p>
        <p>UCDP最佳估值包括一年内所有战斗相关事件的最可靠的汇总数据。若不同报告给出不同的估计，需要检验哪种信源是最可靠的。如果没有此类区别，UCDP规则是取较低的数字。</p>
        <p>统计范围：</p>
        <p>1989-2020年，99个国家和地区。</p>
        <p>
          <a name="12"></a>
          <strong>（八）外部制裁（GSDB）</strong>
        </p>
        <p>指标说明：</p>
        <p>外部制裁（GSDB）涵盖了1950-2019年期间约1100个可公开追溯的、涉及多边、诸边和纯双边的制裁案件。GSDB根据三个重要维度对这些制裁进行分类。其一是按照制裁类型（例如贸易制裁、金融制裁和旅行制裁等）来分类。其二是按照制裁背后的政治目标来分类。GSDB系统地将制裁目标划分为不同类别的政策目标（例如政策变化、政治不稳定、防止战争等）。第三，将制裁效果划分为五类，从制裁失败到被制裁对象全面接受制裁方的要求。</p>
        <p>（1）贸易制裁方面：受到贸易制裁赋值为1，否则为0；贸易制裁的类型分为以下四种：全面出口制裁（exp_compl）、全面的进口制裁（imp_compl）、部分出口制裁（exp_part）、部分进口制裁（imp_part）。</p>
        <p>（2）武器制裁方面：受到武器制裁赋值为1，否则为0。</p>
        <p>（3）军事援助制裁方面：受到军事援助制裁赋值为1，否则为0。</p>
        <p>（4）金融制裁方面：受到金融制裁赋值为1，否则为0。</p>
        <p>（5）旅行制裁方面：受到旅行制裁赋值为1，否则为0。</p>
        <p>（6）其他类型制裁方面：受到其他类型制裁赋值为1，否则为0。</p>
        <p>（7）制裁目标方面：制裁目标包括九种：恐怖主义（terrorism）、结束战争（end_war）、人权（human_rights）、政策变化（policy_change）、民主（democracy）、政治不稳定（destab_regime）、恐怖冲突（territorial_conflict）、防止战争（prevent_war）和其他（other）。如果同一案例有多个制裁目标，则这些目标之间无排名先后之别。</p>
        <p>（8）制裁效果方面：在有多个制裁目标的情况下，制裁成功的顺序对应于制裁目标的顺序。制裁效果指标包括五个：进行中（ongoing）、失败（failed）、谈判和解（nego_settlement）、部分成功（success_part）和全面成功（success_total）。</p>
        <p>统计范围：</p>
        <p>1949年-2019年，168个国家和地区。</p>
        <p>
          <strong>（九）法治程度</strong>
        </p>
        <p>
          <a name="14">9.1有无宪法</a>
        </p>
        <p>指标说明：</p>
        <p>详细列出了截至2020年235个国家和地区有无宪法情况以及现行宪法的生效日期。</p>
        <p>统计范围：</p>
        <p>235个国家和地区，1853-2020年。</p>
        <p>
          <a name="13">9.2宪法修改频率</a>
        </p>
        <p>指标说明：</p>
        <p>加拿大自由市场智库菲莎研究所（Fraser Institute）经济自由度指数中提供了1970-2019年162个国家和地区法治领域9个指标的数据，包括：司法独立（judicial independence）、法庭的公正性（impartial courts）、知识产权保护（protection of property rights）、军队对法治和政治的干预（military interference in rule of law and politics）、法律制度的完整性（integrity of the legal system）、合约的法律效力（legal enforcement of contracts）、不动产出售的监管限制（regulatory restrictions on the sale of real property）、警察的可信度（reliability of police）和性别合法权利调整（Gender Legal Rights Adjustment）。</p>
        <p>统计范围：</p>
        <p>1970-2019年，162个国家和地区。</p>
        <p>
          <a name="法治指数">9.3法治指数</a>
        </p>
        <p>指标说明：</p>
        <p>加拿大自由市场智库菲莎研究所（Fraser Institute）经济自由度指数中提供了1970-2019年162个国家和地区法治领域9个指标的数据，包括：司法独立（judicial independence）、法庭的公正性（impartial courts）、知识产权保护（protection of property rights）、军队对法治和政治的干预（military interference in rule of law and politics）、法律制度的完整性（integrity of the legal system）、合约的法律效力（legal enforcement of contracts）、不动产出售的监管限制（regulatory restrictions on the sale of real property）、警察的可信度（reliability of police）和性别合法权利调整（Gender Legal Rights Adjustment）。</p>
        <p>统计范围：</p>
        <p>1970-2019年，162个国家和地区。</p>
        <p>
          <strong>（十）政策执行</strong>
        </p>
        <p>
          <a name="政策表现">10.1政策表现（Policy Performance）指标</a>
        </p>
        <p>指标说明：</p>
        <p>政策表现指标来源于贝塔斯曼集团（Bertelsmann Stiftung）的可持续治理指数（Sustainable Governance Indicators）数据库，包含OECD和欧洲41个国家2013年至2020年经济、社会、环境三大类政策共23个指标的可持续表现。</p>
        <p>可持续治理指数数据库通过问卷调查及汇总的方式聚合了定性与定量数据，包含3个一级指标、16个二级指标及134个三级指标。其中定性指标基于各国相关领域专家（至少2名）对问卷调查67个问题的打分（1为最低分，10为最高分）。而为了能与定性指标做比较，通过线性转换对定量数据做了1至10的标准化。最后通过简单平均数得到上一级指标。</p>
        <p>统计范围：</p>
        <p>2013年至2020年，41个国家和地区。</p>
        <p>发达经济体经济、社会、环境政策表现</p>
        <div align="center">
          <table class="tableborder1" align="center" cellspacing="0" cellpadding="8">
            <colgroup>
              <col width="173" />
              <col width="276" />
              <col width="119" />
            </colgroup>
            <tbody>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_pp</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>政策表现</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>一级指标</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_ec</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>经济政策表现-总体</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>平均值</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_ecec</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>经济政策表现-经济</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>二级指标</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_ecbg</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>经济政策表现-预算</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>二级指标</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_eclm</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>经济政策表现-劳动力市场</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>二级指标</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_ecri</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>经济政策表现-研究、创新与基础设施</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>二级指标</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_ectx</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>经济政策表现-征税</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>二级指标</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_ecgf</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>经济政策表现-全球金融体系</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>二级指标</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_so</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>社会政策表现：总体</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>平均值</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_soed</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>社会政策表现：教育</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>二级指标</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_sofa</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>社会政策表现：家庭</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>二级指标</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_sohe</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>社会政策表现：健康</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>二级指标</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_soin</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>社会政策表现：整合政策</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>二级指标</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_sope</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>社会政策表现：养老金</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>二级指标</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_sosi</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>社会政策表现：社会包容性</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>二级指标</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_sosl</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>社会政策表现：安全生活环境</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>二级指标</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_sogi</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>社会政策表现：全球社会不平等</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>二级指标</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_en</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>环境政策表现-总体</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>平均值</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_enen</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>环境政策表现-环境</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>二级指标</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="174" height="19">
                  <p>sgi_enge</p>
                </td>
                <td valign="top" width="276" height="19">
                  <p>环境政策表现-全球环境保护</p>
                </td>
                <td valign="top" width="120" height="19">
                  <p>二级指标</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          <a name="国家政策和制度评估（世行）">10.2国家政策和制度评估</a>
        </p>
        <p>指标说明：</p>
        <p>本数据库包含了2005-2020年全球90个国家和地区以下21个指标的治理情况：人力资源评分，营商监管环境评分，债务政策评分，经济管理集群，收入流动效率，公共资源使用平等性评分，金融行业评分，货币政策评分，性别平等评分，宏观经济管理评分，社会包容性，环境可持续部门及政策评分，产权及合规治理评分，公共部门管理和机构集群评分，预算和财务管理质量评分，公共管理质量评分，社会保障评分，结构性政策集群评分，贸易评分，公共部门透明度、问责制、腐败评分和资源分配指数。</p>
        <p>统计范围：</p>
        <p>2005-2020年，90个国家和地区。</p>
        <p>更新时间：</p>
        <p>2021年5月26日。</p>
        <p>
          <a name="全球治理指标">10.3全球政府治理指标</a>
        </p>
        <p>指标说明：</p>
        <p>世界银行的全球政府治理指标(Worldwide Governance Indicators)包含6个方面的治理情况，子指标包括：行政效率（Government Effectiveness）、监管有效性（Regulatory Quality）、话语权和问责制（Voice and Accountability）、法治（Rule of Law）、政治稳定性及无暴乱（Political Stability and Absence of Violence）。</p>
        <p>统计范围：</p>
        <p>1996-2020年，215个国家和地区。</p>
        <p>
          <a name="监管执行">10.4监管执行</a>
        </p>
        <p>指标说明：</p>
        <p>该指数包含一个总体评分和5个二级指标评分（政府监管有效执行、政府监管在无不当干扰下有效执行、行政诉讼不会无缘由地延期、行政诉讼准守法定程序、政府征用应给予适当补偿等）。评分取值范围为0至1，分值越高表明该项表现情况越好。</p>
        <p>统计范围：</p>
        <p>2012-2021年，137个国家和地区。</p>
        <p>（十一）政党开放度</p>
        <p>
          <a name="3">11.1政党开放度</a>
        </p>
        <p>指标说明：</p>
        <p>
          政党数据库（Political parties
          Database）是由美国休斯顿大学政治系建立的在线公共数据库。该数据库包含了有关政党组织、党派资源、领导选举、以及许多代议制民主国家中党派政治参与等信息，该数据库总计统计了各政党427项指标。
        </p>
        <p>统计范围：</p>
        <p>2002年-2019年，51个国家和地区288个政党</p>
        <p>政党数据库相关指标解释</p>
        <div align="center">
          <table class="tableborder1" align="center" cellspacing="0" cellpadding="8">
            <colgroup>
              <col width="173" />
              <col width="424" />
            </colgroup>
            <tbody>
              <tr height="29">
                <td width="174" height="29" valign="top" bgcolor="#f0f0f0">
                  <p>原指标</p>
                </td>
                <td width="425" height="29" valign="top" bgcolor="#f0f0f0">
                  <p>中文翻译</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>COUNTRY</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>国家</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>YEAR</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>年份</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A1RGSTR1</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>是否有注册要求</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A2RGSTR2</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>是否有注册党员最低数量要求</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A3RGSTR3</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>注册所需最低签名个数</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A4RECPARTYTXT</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>党派被国会正式承认要满足的条件</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A5RECPPGTXT</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>党派被国会正式承认需要满足的条件</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A6SUBSIDY</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>国家对党派外部日常活动直接拨款的种类</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A7SUBVOTE</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>补贴分配情况：最近一次国会选举获得的投票占比或数量</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A8SUBSEAT</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>补贴分配情况：最近一次国会选举获得席位数</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A9SUBMBR</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>补贴分配情况：党派成员数量</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A10SUBDONR</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>补贴分配情况：党派从非津贴来源获得的资金</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A11SUBLOCAL</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>补贴分配情况：是否是本地党派</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A12SUBSTATE</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>补贴分配情况：州/地区党派</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A13SUBNAT</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>补贴分配情况：国家党派</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A14SUBCAND</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>补贴分配情况：候选人</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A15SUBSMALL</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>党派在下议院没有席位但获得直接政府津贴</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A16SUBDENY</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>政府在未达到财务披露要求时，能否保留政府津贴</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A17FINCORP</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>企业/商业对政党的直接捐赠</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A18CORPLMT</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>企业捐赠最大额</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A19FINGRP</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>其它协会对政党的直接捐赠</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A20GRPLMT</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>其它协会对政党捐赠的最大额</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A21FINPRIV</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>个人对政党的捐赠</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A22PRIVLMT</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>个人对政党捐赠的最大额</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A23SPENDPTY</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>政党竞选花费限制</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A24SPENDCAND</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>个人竞选花费限制</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A25DISCLOS</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>达到特定捐赠数额时，政党是否需要公开捐赠人的姓名</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A26STAFHQ</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>国家政党总部全职工作人员数量</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A27STAFYR</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>员工统计年份</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A28SUBPPG</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>是否有国家津贴支持政党雇佣员工</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A29STAFPPG</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>政党雇佣在下议院工作员工的数量</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A30SUBMP</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>是否有国家津贴支持国会议员雇佣员工</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A31STAFMP</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>下议院中国会议员平均雇佣全职员工的数量</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A32MBRULE</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>党派是否有全国统一的党员标准</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A33MBRJOIN</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>个人能否直接加入国家党派</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A34MBRDATA</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>党员的注册信息是否由党派自己维护</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A37MBRWAIT</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>入党考察时长</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A38SPONSOR</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>入党是否需要1至2个推荐人</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A39GROUPMB</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>是否需要同时是其它组织的会员</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A40AFFIRM</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>是否需要积极遵从党章</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A41EXCLUSIVE</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>要求不能是其它党派的会员</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A42MBRAGE</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>党员年龄下限</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A43MBRDUES</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>是否要交党费</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A44LAPSE</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>多久不交党费会被开出党籍</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A45EXPEL</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>开除党籍是否有正式的规定</p>
                </td>
              </tr>
              <tr height="29">
                <td valign="top" width="174" height="29">
                  <p>A46LOWLVL</p>
                </td>
                <td valign="top" width="425" height="29">
                  <p>最底层党支部级别</p>
                </td>
              </tr>
            </tbody>
          </table>
          <p>统计范围：</p>
          <p>2002年-2019年，51个国家288个政党</p>
        </div>
        <p>
          <strong>（十二）阶级固化</strong>
        </p>
        <p>
          <a name="1">12.1 全球代际流动数据库</a>
        </p>
        <p>指标说明：</p>
        <p>全球代际流动数据库 (GDIM) 包含项目组对全球153个经济体从20世纪40年到到80年代的5代人的相对和绝对教育代际流动性的估计，绝对代际流动性是一代人生活水平较父母提高的程度。相对代际流动性是一个人在社会经济中的位置独立于父母的程度。较高的代际相对流动性越高与较低程度的机会不平等相关，反映出人们的人生成就受出生环境影响的程度，例如父母的教育和收入、种族、性别和出生地等。该数据库包含多种不同的绝对和相对流动性度量指标。</p>
        <p>统计范围：</p>
        <p>调查了从1940s到1989年间出生的5代人样本，覆盖全球97%人口，全球153个经济体。</p>
        <p>更新时间：</p>
        <p>2021年9月21日</p>

        <p>
          <a name="2">12.2 分省级的全球代际流动数据库</a>
        </p>
        <p>该数据库涵盖中国、巴西、埃及、尼日利亚以及印度尼西亚等5国分省级80后一代人的教育代际流动性估计。</p>
        <p>全球代际流动数据库指标一览</p>
        <div align="center">
          <table class="tableborder1" align="center" cellspacing="0" cellpadding="8">
            <colgroup>
              <col width="171" />
              <col width="601" />
            </colgroup>
            <tbody>
              <tr height="19">
                <td width="171" height="19" valign="top" bgcolor="#f0f0f0">
                  <p>指标简称</p>
                </td>
                <td width="602" height="19" valign="top" bgcolor="#f0f0f0">
                  <p>指标全称</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>countryname</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Country name</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>wbcode</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>World Bank country code</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>iso3</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>ISO3 country codes</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>region</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Region</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>incgroup2</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Income Groups (2 categories)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>incgroup4</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Income Groups (4 categories)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>fragile</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Harmonized List of Fragile Situations FY 2018</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>survey</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Survey</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>year</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Survey year</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>status</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Retrospective data / Co-residents</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>cohort</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Cohort (which decade individuals are born in)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>parent</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Mothers/Fathers/Average/Max</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>child</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Sons/Daughters/All</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>obs</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Observations in particular cell</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>P1</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Share of parents with ISCED0 (less than primary)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>P2</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Share of parents with ISCED1 (primary)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>P3</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Share of parents with ISCED2 (lower secondary)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>P4</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Share of parents with ISCED3-4 (upper secondary)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>P5</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Share of parents with ISCED5-8 (tertiary)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>C1</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Share of children with ISCED0 (less than primary)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>C2</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Share of children with ISCED1 (primary)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>C3</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Share of children with ISCED2 (lower secondary)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>C4</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Share of children with ISCED3-4 (upper secondary)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>C5</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Share of children with ISCED5-8 (tertiary)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>MEANp</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Mean of parents' years of education</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>MEANc</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Mean of children's years of education</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>SDp</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Standard deviation of parents' years of education</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>SDc</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Standard deviation of children's years of education</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>GINIp</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Gini of parents' years of education</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>GINIc</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Gini of children's years of education</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>IGP</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Intergenerational persistence</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>NL1</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>b1 from child_educ=b0+b1*parent_educ+b2*parent_educ^2</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>NL2</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>b2 from child_educ=b0+b1*parent_educ+b2*parent_educ^2</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>COR</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Pearson's correlation between parent &amp;AMP; child years of educ</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>MAcatM</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Abs. upward mobility (weakly), pr(c&amp;GT;p or c=p=top category)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>MAcatC1</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Abs. upward mobility, pr(c&amp;GT;p given p not in top category)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>Q4_IGpri</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Intergenerational Privilege (prob Qchild = 4 Qparent = 4)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>BHQ1</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Probability child from bottom half ends up in Q1 (lowest quartile)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>BHQ2</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Probability child from bottom half ends up in Q2</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>BHQ3</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Probability child from bottom half ends up in Q3</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>BHQ4</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Probability child from bottom half ends up in Q4 (highest quartile)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>Q4BH</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Probability child from highest quartile ends up in bottom half</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>Q4child</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Probability child is in highest quartile in national distribution</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>Delta50</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Difference in years of schooling, given parents in bottom 50%</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>Asher_Q4_IGpri</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Intergenerational Privilege (prob Qchild = 4 Qparent = 4)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>ThreeGen_obs</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Observations behind 3-generational estimations</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>ThreeGen_IGEp1</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>b1 from child_educ=b0+b1*parent_educ+b2*grandparent_educ</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>ThreeGen_IGEg1</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>b2 from child_educ=b0+b1*parent_educ+b2*grandparent_educ</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>ThreeGen_IGEgsd</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Standard deviation of ThreeGen_IGEg1 estimates</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>All2125_MEANp</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Mean of parents' years of education (respondents aged 21-25)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>All2125_MEANc</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Mean of children's years of education (respondents aged 21-25)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>All2125_IGP</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Intergenerational persistence (respondents aged 21-25)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>All2125_MAcatC1</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Abs. upward mobility, pr(c&amp;GT;p given p not in top cat.) (respondents aged 21-25)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>Cores2125_MEANp</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Mean of parents' years of education (coresidents aged 21-25)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>Cores2125_MEANc</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Mean of children's years of education (coresidents aged 21-25)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>Cores2125_IGP</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Intergenerational persistence (coresidents aged 21-25)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>Cores2125_MAcatC1</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Abs. upward mobility, pr(c&amp;GT;p given p not in top cat.) (coresidents aged 21-25)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>Shortfall0611_obs</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Observations in particular cell of Shortfall0611_IGP</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>Shortfall0611_IGP</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Intergenerational persistence (shortfall, children aged 6-11)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>Shortfall1217_obs</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Observations in particular cell of Shortfall1217_IGP</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>Shortfall1217_IGP</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Intergenerational persistence (shortfall, children aged 12-17)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>IGEincome</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Relative IGM in income</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>S1</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>IGEincome share, effect of parent_educ on child_inc via child_educ</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>S2</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>IGEincome share, effect of parent_educ on child_inc (other than via child_educ)</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>S3</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>IGEincome share, effect of parent_char (income, networks etc.) on child_inc</p>
                </td>
              </tr>
              <tr height="19">
                <td valign="top" width="171" height="19">
                  <p>MLD_psu</p>
                </td>
                <td valign="top" width="602" height="19">
                  <p>Mean log deviation-primary sampling unit</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          <strong>（十三）言论自由</strong>
        </p>
        <p>
          <a name="全球媒体自由指数">13.1世界媒体自由指数</a>
        </p>
        <p>指标说明：</p>
        <p>本数据库的言论自由数据来源于无国界记者组织的世界媒体自由指数。该指数广受世界各大媒体引用与参考，并为联合国和世界银行等国际组织和各国外交官所使用。该指数自2002年起每年发布，覆盖全球180个国家，至今已发布16次。该指数以接受无国界组织调查问卷的专家意见汇总得到，此外还结合了评价期内各国家和地区针对记者的侮辱和暴力数据。自2013年以来，指数对各国家和地区进行赋值，赋值区间在0-100之间，最佳情况赋值为100，最差情况赋值为0。</p>
        <p>统计范围：</p>
        <p>2002年&mdash;2018年，全球180个国家和地区。</p>
      </div>
      <p>&nbsp;</p>
    </div>
    <Footer />
  </div>
</template>

<script>
import Top from "@/components/top";
import Footer from "@/components/footerchannel";
export default {
  components: {
    Top,
    Footer
  },
  mounted() {
    let currentId = "",
      words = [
        "Risk Score",
        "Domain 1: Interactions with Government",
        "Domain 2 : Anti-Bribery Laws and Enforcement",
        "Domain 3 : Governmental and Civil Service Transparency",
        "Domain 4 : Capacity for Civil Society Oversight"
      ],
      fzzs = [
        "Judicial independence",
        "Impartial courts",
        "Protection of property rights",
        "Military interference in rule of law and politics",
        "Integrity of the legal system",
        "Legal enforcement of contracts",
        "Regulatory restrictions on the sale of real property",
        "Reliability of police",
        "Gender Adjustment",
        "RULE OF LAW",
        "Business costs of crime"
      ];
    if (JSON.stringify(this.$route.query) === "{}") {
      currentId = "宗教人口占比（CCD）";
    } else {
      for (let key in this.$route.query) {
        currentId = key;
      }
    }
    if (
      words.some(item => {
        return currentId === item;
      })
    ) {
      currentId = "商业贿赂风险";
    }
    if (
      fzzs.some(item => {
        return currentId === item;
      })
    ) {
      currentId = "法治指数";
    }
    if (currentId === "政府规模(Fraser)") {
      currentId = "政府规模";
    }
    setTimeout(function() {
      // $('html, body').animate({scrollTop: $("#table1").offset().top - 20}, 500)
      $("html, body").animate(
        { scrollTop: $(`a[name=${currentId}]`).offset().top - 5 },
        10
      );
    }, 50);
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang='less' scoped>
/deep/.guides {
  display: none !important;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.mianbox {
  background-color: #fff;
  margin-top: 10px;
}
.p20 {
  padding: 20px 50px;
}
.zz_box p {
  text-align: left;
  font-size: 15px;
  line-height: 30px;
}
.zz_box p a {
  font-size: 15px;
  font-weight: bold;
  padding-top: 20px;
  display: block;
}

.tableborder1 {
  border-top: 1px solid #ccc;
  border-right: 1px solid#CCC;
  font-family: verdana;
  font-size: 14px;
  line-height: 200%;
  margin: 10px auto;
  width: 100%;
  background: #fff;
}
.tableborder1 caption {
  white-space: nowrap;
  font-size: 14px;
  line-height: 300%;
}
.tableborder1 th {
  border-bottom: 1px solid #ccc;
  border-left: 1px solid #ccc;
  background-color: #f5f5f5;
}
.tableborder1 td {
  border-bottom: 1px solid #ccc;
  border-left: 1px solid #ccc;
  padding: 0px 15px;
  text-align: left;
}

.zz_box table td,
th {
  font-size: 14px;
}
.zz_box table td {
  padding: 12px 8px;
}
.sm_name {
  font-size: 20px;
  color: #1260af;
  font-family: "微软雅黑";
  font-weight: bold;
  padding: 20px 28px;
  border-bottom: 1px dashed #e5e5e5;
}
</style>